<ats-icon name="dash" [title]="'No Data Available' | cmLocalize: locFeature + '/System.Global.Content.NoData'">
</ats-icon>
